import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { NominationLimitService } from '@/app/core/services/nomination-limit/nomination-limit.service';
import {
  LoadNominationLimitDataAction,
  LoadNominationLimitOptionsAction,
  ClearNominationLimitDataAction,
} from './nomination-limit.actions';
import { catchError, tap, throwError } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { EnovaAlertsComponent } from '@/app/core/utils/enova-alerts/enova-alerts.component';
import {
  INominationLimitOptions,
} from '@/app/core/interfaces/nomination-limit.interface';

export interface NominationLimitStateModel {
  nominationLimitData: any[];
  options: INominationLimitOptions | null;
  loaded: boolean;
  optionsLoaded: boolean;
}

export const initialState: NominationLimitStateModel = {
  nominationLimitData: [],
  options: null,
  loaded: false,
  optionsLoaded: false,
};

@State<NominationLimitStateModel>({
  name: 'nominationLimit',
  defaults: initialState,
})
@Injectable()
export class NominationLimitState {
  @Selector()
  static getNominationLimitData(
    state: NominationLimitStateModel
  ): any[] {
    return state?.nominationLimitData || [];
  }

  @Selector()
  static getNominationLimitOptions(
    state: NominationLimitStateModel
  ): INominationLimitOptions | null {
    return state?.options || null;
  }

  @Selector()
  static isLoaded(state: NominationLimitStateModel): boolean {
    return state?.loaded || false;
  }

  @Selector()
  static areOptionsLoaded(state: NominationLimitStateModel): boolean {
    return state?.optionsLoaded || false;
  }

  constructor(
    private nominationLimitService: NominationLimitService,
    private dialog: MatDialog
  ) {}

  @Action(LoadNominationLimitDataAction)
  LoadNominationLimitDataAction(
    ctx: StateContext<NominationLimitStateModel>,
    { query }: LoadNominationLimitDataAction
  ) {
    return this.nominationLimitService.getNominationLimitByPeriodos(query).pipe(
      tap(response => {
        ctx.patchState({
          nominationLimitData: Array.isArray(response) ? response : [],
          loaded: true,
        });
      }),
      catchError(error => {
        // Manejar errores del backend
        const errorResponse = error?.error || error;
        const errorMessage =
          errorResponse?.details ||
          errorResponse?.message ||
          error?.message ||
          'Ha ocurrido un error al obtener los datos de límite de nominación';

        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'error',
            text: errorMessage,
            tittle: 'Error',
            saveButtonText: 'Cerrar',
            hiddeCancelBtn: true,
          },
        });

        return throwError(() => error);
      })
    );
  }

  @Action(LoadNominationLimitOptionsAction)
  LoadNominationLimitOptionsAction(
    ctx: StateContext<NominationLimitStateModel>
  ) {
    return this.nominationLimitService.getNominationLimitOptions().pipe(
      tap(response => {
        ctx.patchState({
          options: response || null,
          optionsLoaded: true,
        });
      }),
      catchError(error => {
        const errorResponse = error?.error || error;
        const errorMessage =
          errorResponse?.details ||
          errorResponse?.message ||
          error?.message ||
          'Ha ocurrido un error al obtener las opciones';

        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'error',
            text: errorMessage,
            tittle: 'Error',
            saveButtonText: 'Cerrar',
            hiddeCancelBtn: true,
          },
        });

        return throwError(() => error);
      })
    );
  }

  @Action(ClearNominationLimitDataAction)
  ClearNominationLimitDataAction(ctx: StateContext<NominationLimitStateModel>) {
    ctx.setState(initialState);
  }
}


